module.exports = __webpack_public_path__ + "static/media/Tornax-OT-3200.2d63ae30.png";